import { render, staticRenderFns } from "./ObservatoryUsageGuide.vue?vue&type=template&id=e5a33844&scoped=true&"
import script from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
export * from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryUsageGuide.vue?vue&type=style&index=0&id=e5a33844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a33844",
  null
  
)

export default component.exports